module.exports = __webpack_public_path__ + "media/vans/van--white-fill-48adaf70.svg";